/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        color: theme.palette.secondary.main,
        letterSpacing: theme.typography.titleLetterSpace,
        lineHeight: '24px',
        verticalAlign: 'top',
        paddingBottom: '32px',
        marginTop: 0,
        marginBottom: 0,
        '@media (max-width:600px)': {
            float: 'left',
        },
    },
    details: {
        color: theme.palette.text.chipgrey,
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: '0.875rem',
        lineHeight: '20px',
        letterSpacing: '0.25px',
        paddingBottom: '48px',
        '@media (max-width:600px)': {
            float: 'left',
            fontSize: '0.75rem',
            lineHeight: '133%',
        },
    },
}));

const PageTitle = ({ title, details, subDetails, fontWeight, id = undefined }) => {
    const classes = useStyles();

    return (
        <>
            <h1 className={classes.title}>{title}</h1>
            <div style={{ clear: 'both' }}></div>
            {!!details && (
                <>
                    <Typography variant="body2" className={classes.details} id={id}>
                        {fontWeight ? <span style={{ fontWeight: fontWeight }}>{details}</span> : details}

                        {subDetails && (
                            <>
                                <br />
                                {subDetails}
                            </>
                        )}
                    </Typography>
                    <div style={{ clear: 'both' }}></div>
                </>
            )}
        </>
    );
};

export default PageTitle;
